class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.predictiveSearchResults2 = this.querySelector('.search-modal__form .template-search__result');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();

    setTimeout(function(){
      document.querySelector('.template-search__search .search__input').focus();
    }, 1);

  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    
     fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.searchTerm)}&section_id=predictive-search`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      var search_result = html.querySelector('.template-search__result');
      
      if(document.querySelector('.template-search__body .template-search__result') != null){
        document.querySelector('.template-search__body .template-search__result').replaceWith(search_result);
      }
    });


    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {

    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
       fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.searchTerm)}&section_id=predictive-search`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        var search_result = html.querySelector('.template-search__result');
        if(document.querySelector('.template-search__body .template-search__result') != null){
          document.querySelector('.template-search__body .template-search__result').replaceWith(search_result);
        }
      });

    }
  }

  // onFocusOut() {
  //   setTimeout(() => {
  //     if (!this.contains(document.activeElement)) this.close();
  //   });
  // }

  onFocusOut() {
  setTimeout(() => {
    const activeEl = document.activeElement;
    if (!this.contains(activeEl) && !activeEl.closest('.predictive-search-keep-open')) {
    }
  });
}

  onKeyup(event) {
    if (!this.getQuery().length) this.close(false);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }
  
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);




// JS

class PredictiveSwiper extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.itemsPerView = 1;
    this.container = null;
    this.items = [];
    this.prevBtn = null;
    this.nextBtn = null;
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    if (window.innerWidth >= 768) {          
      this.initSlider();
      window.addEventListener('resize', this.handleResize);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  initSlider() {
    this.container = this.querySelector('[data-predictive-slide-list]') || this.querySelector('ul'); 
    this.items = Array.from(this.container.children);
    this.prevBtn = this.querySelector('.custom-button-prev');
    this.nextBtn = this.querySelector('.custom-button-next');

    this.updateItemsPerView();
    this.updateTransform();
    this.updateArrows();

    this.prevBtn?.addEventListener('click', () => this.slidePrev());
    this.nextBtn?.addEventListener('click', () => this.slideNext());
  }

  handleResize() {
    if (window.innerWidth < 768) {
      this.container.style.transform = '';
      this.prevBtn?.style.removeProperty('display');
      this.nextBtn?.style.removeProperty('display');
      return;
    }
    this.updateItemsPerView();
    this.updateTransform();
    this.updateArrows();
  }

  updateItemsPerView() {
    const w = window.innerWidth;
    if (w >= 990) {
      this.itemsPerView = 5;
    } else if (w >= 600) {
      this.itemsPerView = 3;
    } else {
      this.itemsPerView = 1;
    }
  }

  slidePrev() {
    this.currentIndex = Math.max(this.currentIndex - 1, 0);
    this.updateTransform();
  }

  slideNext() {
    const maxIndex = Math.max(this.items.length - Math.ceil(this.itemsPerView), 0);
    this.currentIndex = Math.min(this.currentIndex + 1, maxIndex);
    this.updateTransform();
  }

  updateTransform() {
    const itemWidth = 100 / this.itemsPerView; 
    this.items.forEach(item => {
      item.style.flex = `0 0 ${itemWidth}%`;
    });
    const translateX = -(this.currentIndex * (100 / this.itemsPerView));
    this.container.style.display = 'flex';
    this.container.style.transition = 'transform 0.3s ease';
    this.container.style.transform = `translateX(${translateX}%)`;
  }

  updateArrows() {
    if (!this.prevBtn || !this.nextBtn) return;

    const w = window.innerWidth;
    let shouldShow = false;

    if (w >= 990 && this.items.length > 5) {
      shouldShow = true;
    } else if (w >= 600 && this.items.length > 3) {
      shouldShow = true;
    } else if (w < 600 && this.items.length > 1) {
      shouldShow = true;
    }

    this.prevBtn.style.display = shouldShow ? "flex" : "none";
    this.nextBtn.style.display = shouldShow ? "flex" : "none";
  }
}

customElements.define('predictive-swiper', PredictiveSwiper);



class PredictiveTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const tabsSelector = this.getAttribute('tabs-selector') || '.main-predictive-tabs-column li';
    const groupsSelector = this.getAttribute('groups-selector') || '.predictive-search__result-group';
    this.tabs = document.querySelectorAll(tabsSelector);
    this.groups = document.querySelectorAll(groupsSelector);
    this.viewAllBtns = document.querySelectorAll('.main-view-all-btn');
    if (!this.tabs.length || !this.groups.length) return;

    this.tabs.forEach(tab => {
      tab.addEventListener('click', e => {
        e.preventDefault();
        this.switchTab(tab);
      });
    });

    const defaultTab =
      Array.from(this.tabs).find(t => t.getAttribute('data-tab') === 'product') ||
      this.tabs[0];

    if (defaultTab) {
      this.switchTab(defaultTab);
    }
  }

  switchTab(tab) {
    const selectedTab = tab.getAttribute('data-tab');
    this.tabs.forEach(t => t.classList.remove('is--active'));
    this.groups.forEach(group => {
      group.classList.remove('is--active');
      group.style.display = 'none';
    });
    tab.classList.add('is--active');
    const match = document.querySelector(`.predictive-search__result-group[data-id="${selectedTab}"]`);
    if (match) {
      match.style.display = 'block';
      match.classList.add('is--active');
    }

    this.viewAllBtns.forEach(btn => {
      if (btn.getAttribute('data-value') === selectedTab) {
        btn.style.display = 'block';
        btn.classList.add('is--active');
      } else {
        btn.style.display = 'none';
        btn.classList.remove('is--active');
      }
    });
  }
}

customElements.define('predictive-tabs', PredictiveTabs);
